import React from "react";
import classnames from "classnames";

const TEXT_SIZES = Object.freeze({
  hero: {
    largeTextClasses: "text-hero",
    marginTop: "5px",
    smallTextClasses: "text-sm",
  },
  large: {
    largeTextClasses: "text-lg",
    marginTop: "2px",
    smallTextClasses: "small-text",
  },
});

type Props = {
  dollars: string | number;
  cents: string | number;
  size?: "hero" | "large";
  symbol?: string;
};

export default function BigPrice({
  dollars,
  cents,
  size = "hero",
  symbol = "$",
}: Props) {
  cents = String(Number(cents)).padStart(2, "0");

  const { largeTextClasses, smallTextClasses, marginTop } = TEXT_SIZES[size];

  return (
    <div className="font-bold font-headers whitespace-nowrap">
      <style jsx>{`
        .small-text {
          font-size: 15px;
        }
      `}</style>
      <span
        className={classnames("inline-block align-top", smallTextClasses)}
        style={{ marginTop }}
      >
        {symbol}
      </span>
      <span className={largeTextClasses}>{dollars}</span>
      <span
        className={classnames("inline-block align-top", smallTextClasses)}
        style={{ marginLeft: "1px", marginTop }}
      >
        <span className="-ml-xs opacity-0">.</span>
        {cents}
      </span>
    </div>
  );
}
